module.exports = __webpack_public_path__ + "img/erweima.aa4ce7ac.png";